import { TableItemNumber, TableItemTime } from './table';

export function SummaryTable ({ evidenceTree, totalMs, engineTime, totalConditionCount, callDatasourceCount, callDatasourceTime, numberFormat }) {
	return (<table>
		<tbody>
			<tr>
				<td>Evidence Tree</td>
				<td>
					{ evidenceTree ? <a href={evidenceTree} target="_blank" rel="noopener noreferrer">Link</a> : '-' }
				</td>
			</tr>
			<tr>
				<td>Total time</td>
				<td><TableItemTime value={totalMs} inputFormat="ms" bold numberFormat={numberFormat}  /></td>
			</tr>
			<tr>
				<td>Approx engine time</td>
				<td><TableItemTime value={engineTime} inputFormat="ms" bold numberFormat={numberFormat}  /></td>
			</tr>
			<tr>
				<td>Total condition count</td>
				<td>
					<TableItemNumber value={totalConditionCount} bold numberFormat={numberFormat}  />
				</td>
			</tr>
			<tr>
				<td>Calls to datasources</td>
				<td>
					<TableItemNumber value={callDatasourceCount} bold numberFormat={numberFormat}  />
				</td>
			</tr>
			<tr>
				<td>Total datasource time</td>
				<td><TableItemTime value={callDatasourceTime} bold numberFormat={numberFormat}  inputFormat="ms" /></td>
			</tr>
		</tbody>
	</table>);
}



// WEBPACK FOOTER //
// ./components/summary-table.js